

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"18"}, rest), [h('g', {"fill":"#FFFFFF","fill-rule":"evenodd"}, [h('path', {"d":"M25.486.909 13.429 8.143a1 1 0 0 0 0 1.714l12.057 7.234A1 1 0 0 0 27 16.234V1.766A1 1 0 0 0 25.486.91Z"}, []), h('path', {"d":"M13.486.909 1.429 8.143a1 1 0 0 0 0 1.714l12.057 7.234A1 1 0 0 0 15 16.234V1.766A1 1 0 0 0 13.486.91Z"}, [])])]);
};

        